import React from 'react';
import {Link} from 'react-router-dom';
import styles from './Button.module.scss';

// 大而圆润、带 3D 底边压感的按钮，适合小学生点击
// variant: primary | secondary | success | ghost | soft
export default function Button ({
    children,
    variant = 'primary',
    size = 'md',
    to,
    href,
    iconLeft,
    iconRight,
    block,
    className = '',
    ...rest
}) {
    const cls = [
        styles.btn,
        styles[variant],
        styles[size],
        block ? styles.block : '',
        className
    ].filter(Boolean).join(' ');

    const inner = (
        <>
            {iconLeft && <span className={styles.icon}>{iconLeft}</span>}
            <span className={styles.label}>{children}</span>
            {iconRight && <span className={styles.icon}>{iconRight}</span>}
        </>
    );

    if (to) return <Link to={to} className={cls} {...rest}>{inner}</Link>;
    if (href) return <a href={href} className={cls} {...rest}>{inner}</a>;
    return <button className={cls} {...rest}>{inner}</button>;
}
